export enum APP_STATES {
  IDLE = 'IDLE',
  ERROR = 'ERROR',
  USER = 'USER',
  CLIENT = 'CLIENT',
}
